// import React, { useState } from 'react';
// import { Navigate, Outlet } from 'react-router-dom';
// import Sidebar from '../SideBar/SideBar';
// import Topbar from '../TopBar/Topbar';
// import styles from './MainLayout.module.css';

// const MainLayout = () => {
//     const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//     const isLogin = Boolean(localStorage.getItem("token"));

//     if (!isLogin) {
//         return <Navigate to="/login" />;
//     }

//     const toggleSidebar = () => {
//         setIsSidebarOpen(!isSidebarOpen);
//     };

//     return (
//         <div className={styles.layout}>
//             <Sidebar isOpen={isSidebarOpen} onToggle={toggleSidebar} />
//             <Topbar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
//             <main className={`${styles.main} ${isSidebarOpen ? styles.expanded : styles.collapsed}`}>
//                 <Outlet />
//             </main>
//         </div>
//     );
// };

// export default MainLayout;

// import React, { useState, useEffect } from 'react';
// import { Navigate, Outlet } from 'react-router-dom';
// import Sidebar from '../SideBar/SideBar';
// import Topbar from '../TopBar/Topbar';
// import styles from './MainLayout.module.css';

// const MainLayout = () => {
//     const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//     const [isMobile, setIsMobile] = useState(false);
//     const isLogin = Boolean(localStorage.getItem("token"));

//     // ✅ FIXED: Hooks must be called BEFORE any conditional returns
//     // Detect mobile viewport
//     useEffect(() => {
//         const checkMobile = () => {
//             const mobile = window.innerWidth <= 768;
//             setIsMobile(mobile);

//             // Auto-close sidebar on mobile by default
//             if (mobile && isSidebarOpen) {
//                 setIsSidebarOpen(false);
//             }
//         };

//         // Initial check
//         checkMobile();

//         // Add resize listener
//         window.addEventListener('resize', checkMobile);

//         // Cleanup
//         return () => window.removeEventListener('resize', checkMobile);
//     }, []); // eslint-disable-line react-hooks/exhaustive-deps

//     // Check authentication AFTER hooks
//     if (!isLogin) {
//         return <Navigate to="/login" />;
//     }

//     const toggleSidebar = () => {
//         setIsSidebarOpen(!isSidebarOpen);
//     };

//     const closeSidebar = () => {
//         if (isMobile) {
//             setIsSidebarOpen(false);
//         }
//     };

//     return (
//         <div className={styles.layout} data-theme="default">
//             {/* Sidebar */}
//             <Sidebar
//                 isOpen={isSidebarOpen}
//                 onToggle={toggleSidebar}
//                 isMobile={isMobile}
//             />

//             {/* Backdrop for mobile drawer */}
//             {isMobile && isSidebarOpen && (
//                 <div
//                     className={styles.backdrop}
//                     onClick={closeSidebar}
//                     aria-hidden="true"
//                 />
//             )}

//             {/* Topbar */}
//             <Topbar
//                 toggleSidebar={toggleSidebar}
//                 isSidebarOpen={isSidebarOpen}
//                 isMobile={isMobile}
//             />

//             {/* Main Content Area */}
//             <main
//                 className={`${styles.main} ${isSidebarOpen ? styles.expanded : styles.collapsed} ${isMobile ? styles.mobile : ''}`}
//             >
//                 <div className={styles.mainContent}>
//                     <Outlet />
//                 </div>
//             </main>
//         </div>
//     );
// };

// export default MainLayout;

import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Sidebar from '../SideBar/SideBar';
import Topbar from '../TopBar/Topbar';
import styles from './MainLayout.module.css';

const MainLayout = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const [isTablet, setIsTablet] = useState(false);
    const isLogin = Boolean(localStorage.getItem("token"));

    // Detect mobile and tablet viewport
    useEffect(() => {
        const checkViewport = () => {
            const width = window.innerWidth;
            const mobile = width <= 768;
            const tablet = width > 768 && width <= 1024;

            setIsMobile(mobile);
            setIsTablet(tablet);

            // Auto-close sidebar on mobile by default
            if (mobile) {
                setIsSidebarOpen(false);
            }
            // Auto-collapse sidebar on tablet by default
            else if (tablet) {
                setIsSidebarOpen(false);
            }
        };

        // Initial check
        checkViewport();

        // Add resize listener with debounce
        let resizeTimer;
        const handleResize = () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(checkViewport, 150);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(resizeTimer);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // Check authentication AFTER hooks
    if (!isLogin) {
        return <Navigate to="/login" />;
    }

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const closeSidebar = () => {
        if (isMobile || isTablet) {
            setIsSidebarOpen(false);
        }
    };

    return (
        <div className={styles.layout} data-theme="default">
            {/* Sidebar */}
            <Sidebar
                isOpen={isSidebarOpen}
                onToggle={toggleSidebar}
                isMobile={isMobile}
            />

            {/* Backdrop for mobile drawer */}
            {isMobile && isSidebarOpen && (
                <div
                    className={styles.backdrop}
                    onClick={closeSidebar}
                    aria-hidden="true"
                />
            )}

            {/* Topbar */}
            <Topbar
                toggleSidebar={toggleSidebar}
                isSidebarOpen={isSidebarOpen}
                isMobile={isMobile}
            />

            {/* Main Content Area */}
            <main
                className={`${styles.main} ${isMobile
                    ? styles.mobile
                    : isSidebarOpen
                        ? styles.expanded
                        : styles.collapsed
                    }`}
            >
                <div className={styles.mainContent}>
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default MainLayout;